// extracted by mini-css-extract-plugin
module.exports = {"hero":"Hero_hero__17A-X","placeholder":"Hero_placeholder__zODfJ","small":"Hero_small__1qZAk"};